import { EventName } from '@lit/react';
import { BlocksTextareaField } from 'blocks-nextjs/blocks-web-components/components/textarea-field/textarea-field';
import { BlocksChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTextareaField = createComponent({
  react: React,
  tagName: 'cat-textarea-field',
  elementClass: BlocksTextareaField,
  events: {
    onBlChange: 'bl-change' as EventName<BlocksChangeEvent>
  }
});
